import React from 'react';

import AppDashboard from '../AppDashboard';
import TestGeolocation from '../../components/locations/TestGeolocation';

const AdminGeolocationPage = () => {
  return (
    <AppDashboard>
      <TestGeolocation />
    </AppDashboard>
  );
};

export default AdminGeolocationPage;